import React from "react";
import styles from "./AppFooter.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

export default function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={`border-top ${styles.footer}`}>
      <div className="container-fluid py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        {/* Left */}
        <div className="d-flex align-items-center gap-2 text-secondary small">
          © {year} <span className="fw-semibold">Pocket Penny</span>
        </div>

        {/* Center (optional links, easy to expand later) */}
        <nav className="d-flex gap-3 text-secondary small">
          <a href="/app/settings" className="text-decoration-none text-secondary hover-link">
            Settings
          </a>
          <a href="/privacy" className="text-decoration-none text-secondary hover-link">
            Privacy
          </a>
          <a href="/terms" className="text-decoration-none text-secondary hover-link">
            Terms
          </a>
        </nav>

        {/* Right */}
        <div className="text-secondary small d-flex align-items-center gap-1">
          Built with
          <FontAwesomeIcon icon={faHeart} className={styles.heart} />
          for better finances
        </div>
      </div>
    </footer>
  );
}
